export function shouldRenderProducerField(tableName: string, mode: "create" | "edit", columnName: string): boolean {
    return !(tableName === "sys_tables" && mode === "create" && columnName === "schema_version");
}
